<abs-modals-and-alerts-component [(modalAction)]="openModal" (modalClosed)="closePopup($event, 'openModal')"
  windowClass="modal-docked" sizeClass="modal-small">
  <abs-modals-and-alerts-content-component id="customer-inactivity-modal-popup">
    <div class="modal-header">
      <h1 style="display:none;">Modal Heading</h1>
      <h2 id="customer-inactivity-modal-container" [innerHTML]="cfetLabels.cfet_customer_inactivity_modal.heading"></h2>
      <div class="corner-button">
        <button type="button" id="close-btn" class="close-modal-button" tabindex="0" [attr.aria-label]="'Close'"
          (click)="closePopup($event, 'openModal')" (keyup)="closePopup($event,'openModal')">
          <em aria-label="Close" id="icon-close" class="icon-close modal-close-icon" role="img"></em>
        </button>
      </div>
    </div>
    <div class="modal-body" id="confirmation-buttons-section" modal-content>
      <div id="modal-desc">
        <p id="description" [innerHTML]="cfetLabels.cfet_customer_inactivity_modal.description"></p>
      </div>
      <div id="keep-moving-buttons">
        <button type="button" id="btn-stay" (click)="continueWorking($event,'openModal')"
          (keyup)="continueWorking($event,'openModal')" class="btn btn-alt btn-medium" tabindex="0"><em
            aria-label=""></em>
          {{cfetButtonLabels.button_labels.keep}}</button>
      </div>
    </div>
  </abs-modals-and-alerts-content-component>
</abs-modals-and-alerts-component>